import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { isImageLike, isVideoLike } from '@tencent/docs-mime-types';
import { nodeJoinMethod } from "../get-local-folder-for-file";
import { pathToFileUrl } from "../path-to-file-url";
import { DEFAULT_CREATOR_DOMAIN, DEFAULT_DOMAIN_ID, DocPolicy, DocSource, DocStatus, DRIVE_FILE_KIND, DriveFileType } from "../../model/drive-file";
import { Backend } from "../../types/backend";
/**
 * 客户端编码 location.search 的时候，使用的 application/x-www-form-urlencoded 格式的编码规则，会把空格转换成 + 号。
 * 所以不适用 RFC 3986 标准的 encodeURIComponent/decodeURIComponent，所以这里用 URLSearchParams get 会更适合。
 */
var getLocalFilePath = function getLocalFilePath() {
  var _URLSearchParams$get, _window, _window$location, _window$location$sear;
  return (_URLSearchParams$get = new URLSearchParams((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : (_window$location$sear = _window$location.search) === null || _window$location$sear === void 0 ? void 0 : _window$location$sear.slice(1)).get('localFilePath')) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : '';
};

/**
 * .filemeta.json 数据结构：
 * ```json
 * {
 *   // 版本号
 *   "version": "0.0.1",
 *   "data": [{
 *       "filename": "附件/李克勤 - 开学礼.mp3",
 *       "objKey": "5f794bcbe8a14d589c504cf6e9a170af",
 *       // 由 drive/fileInfo，drive/query 的组合信息。
 *       "fileMeta": {...}
 *   }]
 * }
 * ```
 */
/**
 * .filemeta.json 文件转换器
 * 1. 负责获取当前文档本地 .filemeta.json
 * 2. 建立映射 objKey: fileMeta
 * 3. 建立缓存
 */
var FileMetaTransfer = /*#__PURE__*/function () {
  function FileMetaTransfer() {
    _classCallCheck(this, FileMetaTransfer);
    _defineProperty(this, "fileMetaItemMap", new Map());
  }
  _createClass(FileMetaTransfer, [{
    key: "getFileMetaItem",
    value: function () {
      var _getFileMetaItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var fileMetaItem;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              fileMetaItem = this.fileMetaItemMap.get(id); // 不存在，动态获取数据
              if (fileMetaItem) {
                _context.next = 8;
                break;
              }
              _context.t0 = this;
              _context.next = 5;
              return this.getFileMetaJSON();
            case 5:
              _context.t1 = _context.sent;
              _context.t0.fillFileMetaItemMap.call(_context.t0, _context.t1);
              fileMetaItem = this.fileMetaItemMap.get(id);
            case 8:
              return _context.abrupt("return", fileMetaItem);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getFileMetaItem(_x) {
        return _getFileMetaItem.apply(this, arguments);
      }
      return getFileMetaItem;
    }() // 获取 filemeta.json 内容
  }, {
    key: "getFileMetaJSON",
    value: function () {
      var _getFileMetaJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var localDocsFilePath, localFileDir, replaceLocalFileDir, fileMetaPath, resp, fileMetaJSON;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 获取本地文档路径，
              // mac: localFilePath=/Users/JerryC/Workspace/tencent/本地预览技术调研/Office本地编辑文件/无标题表格.xlsx
              // win: C:\\test\\Drive-test\\Drive.xlsx
              localDocsFilePath = getLocalFilePath();
              if (localDocsFilePath) {
                _context2.next = 3;
                break;
              }
              throw new Error('localFilePath 不存在与 location.href 中，非本地编辑场景');
            case 3:
              _context2.next = 5;
              return pathToFileUrl([localDocsFilePath, '..']);
            case 5:
              localFileDir = _context2.sent;
              replaceLocalFileDir = localFileDir.replace(/^file/, 'attachment-preview');
              if (replaceLocalFileDir) {
                _context2.next = 9;
                break;
              }
              throw new Error("localFileDir \u8BA1\u7B97\u9519\u8BEF, localDocsFilePath: ".concat(localDocsFilePath));
            case 9:
              // filemeta.json 路径
              fileMetaPath = "".concat(replaceLocalFileDir, "/.meta/filemeta.json"); // 通过客户端特殊协议，获取 json 数据
              _context2.next = 12;
              return fetch("".concat(fileMetaPath));
            case 12:
              resp = _context2.sent;
              _context2.next = 15;
              return resp.json();
            case 15:
              fileMetaJSON = _context2.sent;
              return _context2.abrupt("return", fileMetaJSON);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getFileMetaJSON() {
        return _getFileMetaJSON.apply(this, arguments);
      }
      return getFileMetaJSON;
    }() // 建立映射
  }, {
    key: "fillFileMetaItemMap",
    value: function fillFileMetaItemMap(fileMetaJSON) {
      var _fileMetaJSON$data,
        _this = this;
      (_fileMetaJSON$data = fileMetaJSON.data) === null || _fileMetaJSON$data === void 0 ? void 0 : _fileMetaJSON$data.forEach(function (item) {
        _this.fileMetaItemMap.set(item.objKey, item);
      });
    }
  }]);
  return FileMetaTransfer;
}();
/**
 * 本地编辑场景下的 DriveFileDTO
 * 依赖：
 * 1. location.href 中的 localFilePath
 * 2. localFilePath 相对目录下的 .filemeta.json 文件
 *
 */
export var LocalDriveFileDTO = /*#__PURE__*/function () {
  function LocalDriveFileDTO(params) {
    _classCallCheck(this, LocalDriveFileDTO);
    // 保存的 driveFile 数据模型
    _defineProperty(this, "driveFile", void 0);
    // 用于获取 driveFile 的接口参数
    _defineProperty(this, "params", void 0);
    _defineProperty(this, "fileMetaTransfer", new FileMetaTransfer());
    if (!params) throw new Error('params required');
    this.params = params;
  }

  /**
   * 获取 DriveFile，并保存起来
   */
  _createClass(LocalDriveFileDTO, [{
    key: "fetchDriveFile",
    value: function () {
      var _fetchDriveFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var fileMetaItem;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.fileMetaTransfer.getFileMetaItem(this.params.id);
            case 2:
              fileMetaItem = _context3.sent;
              if (fileMetaItem) {
                _context3.next = 5;
                break;
              }
              throw new Error("\u627E\u4E0D\u5230 fileMeta, id: ".concat(this.params.id));
            case 5:
              _context3.next = 7;
              return this.transformLocalFileMetaItemToDriveFile(fileMetaItem);
            case 7:
              this.driveFile = _context3.sent;
              return _context3.abrupt("return", this.driveFile);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchDriveFile() {
        return _fetchDriveFile.apply(this, arguments);
      }
      return fetchDriveFile;
    }() // 格式化数据
    // eslint-disable-next-line max-lines-per-function
  }, {
    key: "transformLocalFileMetaItemToDriveFile",
    value: function () {
      var _transformLocalFileMetaItemToDriveFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(fileMetaItem) {
        var _fileMetaItem$fileMet, _fileMetaItem$fileMet2, _fileMeta$cosInfo, _privilege$policy, _fileMeta$status, _fileMeta$tencentDocU;
        var _ref, fileMeta, docInfo, privilege, mimeType, owner, operator, _yield$this$transform, _yield$this$transform2, previewInfo, _yield$this$transform3, thumbnailUrl, localPath, driveFile;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref = (_fileMetaItem$fileMet = (_fileMetaItem$fileMet2 = fileMetaItem.fileMeta) === null || _fileMetaItem$fileMet2 === void 0 ? void 0 : _fileMetaItem$fileMet2.fileInfo) !== null && _fileMetaItem$fileMet !== void 0 ? _fileMetaItem$fileMet : {}, fileMeta = _ref.fileMeta, docInfo = _ref.docInfo, privilege = _ref.privilege, mimeType = _ref.mimeType, owner = _ref.owner, operator = _ref.operator;
              _context4.next = 3;
              return this.transformLocalFileMetaItemToPreviewInfo(fileMetaItem);
            case 3:
              _yield$this$transform = _context4.sent;
              _yield$this$transform2 = _slicedToArray(_yield$this$transform, 2);
              previewInfo = _yield$this$transform2[0];
              _yield$this$transform3 = _yield$this$transform2[1];
              thumbnailUrl = _yield$this$transform3.thumbnailUrl;
              localPath = _yield$this$transform3.localPath;
              driveFile = {
                isTrashed: (docInfo === null || docInfo === void 0 ? void 0 : docInfo.docStatus) === DocStatus.MovedToTrash,
                driveFileType: DriveFileType.LOCAL_ATTACHMENT,
                /**
                 * 附件：fileId 存在
                 * 云文件：fileId 为空，cosInfo.cosId 位 objKey
                 */
                // @ts-ignore
                id: fileMeta !== null && fileMeta !== void 0 && fileMeta.fileId ? fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.fileId : fileMeta === null || fileMeta === void 0 ? void 0 : (_fileMeta$cosInfo = fileMeta.cosInfo) === null || _fileMeta$cosInfo === void 0 ? void 0 : _fileMeta$cosInfo.cosId,
                hostId: fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.hostFileId,
                kind: DRIVE_FILE_KIND,
                ext: fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.ext,
                creatorDomainId: (docInfo === null || docInfo === void 0 ? void 0 : docInfo.creatorDomain) || DEFAULT_CREATOR_DOMAIN,
                domainId: (docInfo === null || docInfo === void 0 ? void 0 : docInfo.domainId) || DEFAULT_DOMAIN_ID,
                clientId: (fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.clientId) || null,
                groupChatKey: '',
                // 待确认
                groupName: '',
                // 待确认
                isCollected: false,
                // 待确认
                isPinned: false,
                // 待确认
                lastCollectTs: 0,
                // 待确认
                lastPinnedTs: 0,
                // 待确认
                officialAuthInfo: null,
                // 待确认,
                personalizeInfo: null,
                // 待确认
                previewInfo: previewInfo,
                auditStatus: null,
                // 待确认
                size: Number(fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.size),
                operator: operator,
                privilege: {
                  isAuth: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.isAuth,
                  canCopy: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canCopy,
                  canPrint: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canPrint,
                  canRead: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canRead,
                  canReadRevisions: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canHistory,
                  canRename: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canEditTitle,
                  canSearchContent: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canSearch,
                  canAddUser: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canAddUser,
                  canViewImage: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canViewImage,
                  canEdit: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canEdit,
                  canShare: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canShare,
                  canComment: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canComment,
                  canAbout: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canAbout,
                  canSpitSlot: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canSpitSlot,
                  canSetWatermark: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canWatermark,
                  canUseTranslate: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canTranslate,
                  canSetLinkExp: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canLinkExp,
                  canCopyFile: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canCopyDoc,
                  canPublish: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canPublish,
                  canSetRange: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canSetRange,
                  canEditTab: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canEditTab,
                  canExport: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canExport,
                  canApplyEditPermission: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canApplyEditPermission,
                  canSaveAsTemplate: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.canSaveAsTemplate,
                  policy: privilege === null || privilege === void 0 ? void 0 : privilege.policy,
                  privilegeFlag: privilege === null || privilege === void 0 ? void 0 : privilege.privilegeFlag
                },
                properties: {},
                policy: (_privilege$policy = privilege === null || privilege === void 0 ? void 0 : privilege.policy) !== null && _privilege$policy !== void 0 ? _privilege$policy : DocPolicy.Private,
                source: DocSource.Personal,
                // 待确认
                status: (_fileMeta$status = fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.status) !== null && _fileMeta$status !== void 0 ? _fileMeta$status : DocStatus.Normal,
                // 待确认, 应该是这个
                tenantId: (fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.tenantId) || null,
                // 空字符串 fallback 到 null
                thumbnailUrl: thumbnailUrl !== null && thumbnailUrl !== void 0 ? thumbnailUrl : '',
                url: (_fileMeta$tencentDocU = fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.tencentDocUrl) !== null && _fileMeta$tencentDocU !== void 0 ? _fileMeta$tencentDocU : '',
                weDriveInfo: null,
                // 待确认

                title: fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.name,
                // 待确认, 是 fileMeta.name 吧 ?
                collaborationFlag: fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.collaborationFlag,
                createTs: Number(fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.createTime),
                // 这是一个写成字符串的数字
                creator: {
                  uid: fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.creator,
                  nick: '' // 待确认, 没有看到有 creator 的名字
                },

                docType: 101,
                // 待确认, drive doc type
                iconUrl: (fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.iconUrl) || '',
                lastBrowseTs: 0,
                // 待确认
                lastDeleteTs: 0,
                // 待确认
                lastModifyTs: Number(fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.modifyTime),
                lastModifier: {
                  uid: '',
                  // 待确认
                  nick: '' // 待确认
                },

                mimeType: mimeType !== null && mimeType !== void 0 ? mimeType : 'unknown',
                owner: {
                  uid: fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.owner,
                  nick: owner === null || owner === void 0 ? void 0 : owner.nick,
                  avatarFrameUrl: '',
                  // 待确认
                  expiredStatus: 0,
                  // 待确认
                  vipLevel: 0,
                  // 待确认
                  renewalStatus: 0 // 待确认
                },

                originParentId: null,
                // 待确认
                parentId: fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.fileParentId,
                // 不使用后台返回的 parentId，避免和 SpecialFolderId 混淆
                thirdAppId: null,
                // 待确认
                isOwnedByMe: docInfo === null || docInfo === void 0 ? void 0 : docInfo.isOwner,
                // 待确认, 应该是这个
                localPath: localPath
              };
              return _context4.abrupt("return", driveFile);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function transformLocalFileMetaItemToDriveFile(_x2) {
        return _transformLocalFileMetaItemToDriveFile.apply(this, arguments);
      }
      return transformLocalFileMetaItemToDriveFile;
    }()
    /**
     * 数据转换：filemeta.json → DriveFile['previewInfo']
     */
  }, {
    key: "transformLocalFileMetaItemToPreviewInfo",
    value: function () {
      var _transformLocalFileMetaItemToPreviewInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(fileMetaItem) {
        var docsFilePath, formatPreviewUrl, previewUrl, formatVideoMediaMetadata, formatAudioMediaMetadata, previewInfo, getThumbnailUrl, thumbnailUrl, getLocalPath, localPath;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              // 获取 localFilePath（文档绝对路径）
              docsFilePath = getLocalFilePath(); // 格式化预览链接
              formatPreviewUrl = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                  var previewURL, fileRelativePath, fileAbsolutePath;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        previewURL = null; // 拼接文件绝对路径
                        if (!docsFilePath) {
                          _context5.next = 8;
                          break;
                        }
                        fileRelativePath = fileMetaItem.fileName;
                        _context5.next = 5;
                        return pathToFileUrl([docsFilePath, '../', fileRelativePath]);
                      case 5:
                        fileAbsolutePath = _context5.sent;
                        previewURL = fileAbsolutePath.replace(/^file/, 'attachment-preview');
                        console.log('@@ [previewURL]', previewURL);
                      case 8:
                        return _context5.abrupt("return", previewURL);
                      case 9:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function formatPreviewUrl() {
                  return _ref2.apply(this, arguments);
                };
              }();
              _context8.next = 4;
              return formatPreviewUrl();
            case 4:
              previewUrl = _context8.sent;
              // 格式化视频信息
              formatVideoMediaMetadata = function formatVideoMediaMetadata() {
                var _fileMetaItem$fileMet3, _fileMetaItem$fileMet4, _fileMetaItem$fileMet5, _fileMetaItem$fileMet6, _fileMetaItem$fileMet7;
                var videoMediaMetadata = {
                  width: 0,
                  height: 0,
                  durationSeconds: 0,
                  videoUrl: {}
                };
                if ((_fileMetaItem$fileMet3 = fileMetaItem.fileMeta) !== null && _fileMetaItem$fileMet3 !== void 0 && (_fileMetaItem$fileMet4 = _fileMetaItem$fileMet3.previewInfo) !== null && _fileMetaItem$fileMet4 !== void 0 && (_fileMetaItem$fileMet5 = _fileMetaItem$fileMet4.transcode_detail) !== null && _fileMetaItem$fileMet5 !== void 0 && (_fileMetaItem$fileMet6 = _fileMetaItem$fileMet5[0]) !== null && _fileMetaItem$fileMet6 !== void 0 && (_fileMetaItem$fileMet7 = _fileMetaItem$fileMet6.media) !== null && _fileMetaItem$fileMet7 !== void 0 && _fileMetaItem$fileMet7.video) {
                  var _fileMetaItem$fileMet8, _fileMetaItem$fileMet9, _transcodeTypeMap2Vid;
                  var transcodeDetail = (_fileMetaItem$fileMet8 = fileMetaItem.fileMeta) === null || _fileMetaItem$fileMet8 === void 0 ? void 0 : (_fileMetaItem$fileMet9 = _fileMetaItem$fileMet8.previewInfo) === null || _fileMetaItem$fileMet9 === void 0 ? void 0 : _fileMetaItem$fileMet9.transcode_detail;
                  var transcodeTypeMap2VideoUrlKey = (_transcodeTypeMap2Vid = {}, _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP3Original, 'origin'), _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP4Original, 'origin'), _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP4FLU, 'v480p'), _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP4HD, 'v720p'), _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP4FHD, 'v1080p'), _transcodeTypeMap2Vid);
                  videoMediaMetadata.durationSeconds = parseInt(transcodeDetail[0].media.video.length, 10);
                  var _iterator = _createForOfIteratorHelper(transcodeDetail),
                    _step;
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var _step$value = _step.value,
                        transcodeType = _step$value.transcode_type,
                        status = _step$value.status;
                      if (status === Backend.TranscodeStatus.Success) {
                        var type = transcodeTypeMap2VideoUrlKey[transcodeType];
                        videoMediaMetadata.videoUrl[type] = previewUrl;
                      }
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }
                return videoMediaMetadata;
              }; // 格式化音频信息
              formatAudioMediaMetadata = function formatAudioMediaMetadata() {
                var _fileMetaItem$fileMet10, _fileMetaItem$fileMet11, _fileMetaItem$fileMet12, _fileMetaItem$fileMet13, _fileMetaItem$fileMet14;
                var audioMediaMetadata = {
                  durationSeconds: 0
                };
                if ((_fileMetaItem$fileMet10 = fileMetaItem.fileMeta) !== null && _fileMetaItem$fileMet10 !== void 0 && (_fileMetaItem$fileMet11 = _fileMetaItem$fileMet10.previewInfo) !== null && _fileMetaItem$fileMet11 !== void 0 && (_fileMetaItem$fileMet12 = _fileMetaItem$fileMet11.transcode_detail) !== null && _fileMetaItem$fileMet12 !== void 0 && (_fileMetaItem$fileMet13 = _fileMetaItem$fileMet12[0]) !== null && _fileMetaItem$fileMet13 !== void 0 && (_fileMetaItem$fileMet14 = _fileMetaItem$fileMet13.media) !== null && _fileMetaItem$fileMet14 !== void 0 && _fileMetaItem$fileMet14.audio) {
                  var _fileMetaItem$fileMet15, _fileMetaItem$fileMet16;
                  var transcodeDetail = (_fileMetaItem$fileMet15 = fileMetaItem.fileMeta) === null || _fileMetaItem$fileMet15 === void 0 ? void 0 : (_fileMetaItem$fileMet16 = _fileMetaItem$fileMet15.previewInfo) === null || _fileMetaItem$fileMet16 === void 0 ? void 0 : _fileMetaItem$fileMet16.transcode_detail;
                  audioMediaMetadata.durationSeconds = parseInt(transcodeDetail[0].media.audio.length, 10);
                }
                return audioMediaMetadata;
              };
              previewInfo = {
                // 这里需要集中特殊处理一下后台返回的预览链接
                url: previewUrl || '',
                // 预览 office 文档时 iframe 内嵌文档的 file_id，用于「转在线编辑」时调用生成副本接口
                videoMediaMetadata: formatVideoMediaMetadata(),
                audioMediaMetadata: formatAudioMediaMetadata(),
                imageMediaMetadata: null
              };
              getThumbnailUrl = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                  var _fileMetaItem$fileMet17, _fileMetaItem$fileMet18, _fileMetaItem$fileMet19;
                  var mimeType, _fileMetaItem$fileMet20, _fileMetaItem$fileMet21, fileAbsolutePath, _thumbnailUrl;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        mimeType = (_fileMetaItem$fileMet17 = (_fileMetaItem$fileMet18 = fileMetaItem.fileMeta) === null || _fileMetaItem$fileMet18 === void 0 ? void 0 : (_fileMetaItem$fileMet19 = _fileMetaItem$fileMet18.fileInfo) === null || _fileMetaItem$fileMet19 === void 0 ? void 0 : _fileMetaItem$fileMet19.mimeType) !== null && _fileMetaItem$fileMet17 !== void 0 ? _fileMetaItem$fileMet17 : ''; // 图片类型直接取原图
                        if (!isImageLike(mimeType)) {
                          _context6.next = 3;
                          break;
                        }
                        return _context6.abrupt("return", previewInfo.url);
                      case 3:
                        if (!isVideoLike(mimeType)) {
                          _context6.next = 10;
                          break;
                        }
                        _context6.next = 6;
                        return pathToFileUrl([docsFilePath, '../', (_fileMetaItem$fileMet20 = (_fileMetaItem$fileMet21 = fileMetaItem.fileMeta) === null || _fileMetaItem$fileMet21 === void 0 ? void 0 : _fileMetaItem$fileMet21.thumbnailPath) !== null && _fileMetaItem$fileMet20 !== void 0 ? _fileMetaItem$fileMet20 : '']);
                      case 6:
                        fileAbsolutePath = _context6.sent;
                        _thumbnailUrl = fileAbsolutePath.replace(/^file/, 'attachment-preview');
                        console.log('@@ [thumbnailUrl]', _thumbnailUrl);
                        return _context6.abrupt("return", _thumbnailUrl);
                      case 10:
                        return _context6.abrupt("return");
                      case 11:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function getThumbnailUrl() {
                  return _ref3.apply(this, arguments);
                };
              }();
              _context8.next = 11;
              return getThumbnailUrl();
            case 11:
              thumbnailUrl = _context8.sent;
              getLocalPath = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        return _context7.abrupt("return", nodeJoinMethod([docsFilePath, '../', fileMetaItem.fileName]));
                      case 1:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function getLocalPath() {
                  return _ref4.apply(this, arguments);
                };
              }();
              _context8.next = 15;
              return getLocalPath();
            case 15:
              localPath = _context8.sent;
              return _context8.abrupt("return", [previewInfo, {
                thumbnailUrl: thumbnailUrl,
                localPath: localPath
              }]);
            case 17:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function transformLocalFileMetaItemToPreviewInfo(_x3) {
        return _transformLocalFileMetaItemToPreviewInfo.apply(this, arguments);
      }
      return transformLocalFileMetaItemToPreviewInfo;
    }()
  }]);
  return LocalDriveFileDTO;
}();
//# sourceMappingURL=local-drive-file-dto.js.map